export enum MenuItemTypeEnum {
    Sort = 1,
    Filter = 2,
    Separator = 3
}
